import React from 'react';
import { Link } from 'react-router-dom';
import './sponsor.css';

function Sponsor() {

  
  return (
    <div className="body-donate">
<a href="/payment">
    <div className="feedback-button">
      <div className="shine"></div>
      <span>Get Registered</span>
    </div>
</a>

    </div>
  );
}

export default Sponsor;


